import { RelationType } from '@/server/MakeSenseApp-backend'

export type RelationItem = {
  value: RelationType
  text: string
}

export const RelationValues: RelationItem[] = [
  { value: RelationType.AISMonitoringReport, text: 'AIS Monitoring Report' },
  { value: RelationType.MarineSurveyData, text: 'Marine Survey Data' },
  { value: RelationType.RTTR, text: 'RTTR' },
  { value: RelationType.SpareParts, text: 'Spare Parts' },
  { value: RelationType.CableShape, text: 'Cable Shape File' }
]
